import { Component, Input, OnInit, ViewChild, Output, EventEmitter, Injector, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Form, NgForm } from '@angular/forms';
import { UserPhoneDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppPhoneType } from '@shared/AppEnums';

@Component({
  moduleId: module.id,
  selector: 'phones',
  templateUrl: './phones.component.html',
  exportAs: 'phonesComponent'
})

export class PhonesComponent extends AppComponentBase implements OnInit {

  phoneType = AppPhoneType;

  @Input("phones") _phones;
  @Input("phoneDto") PhoneDto;
  @Input("requiresAPhone") requiresA: boolean = true;
  @Input("showAdd") showAdd: boolean = true;
  @ViewChild('phonesForm') public phonesForm: NgForm;

  public phones = [];
  countName = 0;

  constructor(
    injector: Injector,
    private cdRef: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit() {

    setTimeout(() => {
      this._phones.forEach(phone => {
        phone.id = this.countName--;
      });
      this.phones = this._phones;
    }, 0);

  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  deletePhone(index: number): void {
    this.phones.splice(index, 1);
  };

  addPhone(): void {

    let phone = new this.PhoneDto();
    phone.id = this.countName--;
    phone.ddi = '55';

    this.phones.push(phone);
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/common/phones/phones.component.ts